import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Actions as FSS_REPORT_ACTIONS } from "../../store/actions/fssReportActions";
import Tooltip from "@/tooltip";
import { Link } from "react-router-dom";
import Styles from "./EIDStyle.module.css";
import { validateMalteseID } from "@/components/common/validation/Validators";

const EIDLoginModal = ({
	modalStatus,
	closeModal,
	peNumber,
	year,
	verifyEIDCredentials,
	loading,
	error,
	forBulkSubmission,
}) => {
	const [data, setData] = useState({ peNumber });
	const [validID, setValidID] = useState();

	const validData = useMemo(() => {
		if (!data?.id || !data?.password || !validID) return false;
		else return true;
	}, [data?.id, data?.password]);

	if (!modalStatus) return null;
	return (
		<div
			className="modal"
			tabIndex="-1"
			role="dialog"
			aria-hidden="true"
			style={{ display: "block", background: "rgba(0,0,0,0.4)", overflow: "auto" }}
		>
			<div className="modal-dialog">
				<div className="modal-content">
					<div className="block block-themed block-transparent remove-margin-b">
						<div className={`block-header ${Styles["bg-primary"]}`}>
							<ul className="block-options">
								<li>
									<button
										type="button"
										onClick={closeModal}
									>
										<XMarkIcon className="h-6 w-6 mr-3 text-white" />
									</button>
								</li>
							</ul>
							<h3 className="block-title">E-ID Login</h3>
						</div>
					</div>
				</div>
				<div className="modal-body bg-white">
					<div className={Styles["title-holder"]}>
						<div className={Styles["title"]}>Sign In</div>
					</div>
					<div className={Styles["subtitle"]}>
						<h3>Sign in with your e-ID Account</h3>
					</div>
					{!forBulkSubmission ? (
						<div className="col-xs-12 pl-0">
							<Tooltip
								as="div"
								className={Styles["form-material"]}
								direction="bottom"
								content={
									<>
										You can change the PE Number in{" "}
										<Link to="/organisation/settings/general">Company Settings</Link>
									</>
								}
								arrowSize={3}
							>
								<label htmlFor="material-text">Company PE Number</label>
								<input
									className={`${Styles["form-control"]} ${Styles["form-input"]}`}
									name="peNumber"
									value={data.peNumber}
									disabled={true}
								/>
							</Tooltip>
						</div>
					) : null}

					<div className="col-xs-12 pl-0">
						<div className={Styles["form-material"]}>
							<label htmlFor="eIDCardNumber">ID Number</label>
							<input
								className={`${Styles["form-control"]} ${Styles["form-input"]}`}
								name="eIDCardNumber"
								id="eIDCardNumber"
								type="text"
								value={data.id}
								aria-invalid={typeof validID === "undefined" ? undefined : validID ? "false" : "true"}
								autoComplete="off"
								onChange={(e) => {
									if (e.target.value) {
										setValidID(validateMalteseID(e.target.value));
									} else {
										setValidID(undefined);
									}
									setData({ ...data, id: e.target.value });
								}}
								onBlur={(e) => {
									const validId = validateMalteseID(e.target.value);
									if (validId) {
										const validatedId = e.target.value.toUpperCase().trim().padStart(8, "0");
										setData({ ...data, id: validatedId });
									}
								}}
							/>
						</div>
					</div>
					<div className="col-xs-12 pl-0">
						<div className={Styles["form-material"]}>
							<label htmlFor="eIDPassword">Password</label>
							<input
								className={`${Styles["form-control"]} ${Styles["form-input"]}`}
								name="eIDPassword"
								id="eIDPassword"
								type="password"
								autoComplete="off"
								value={data.password}
								onChange={(e) => setData({ ...data, password: e.target.value })}
							/>
						</div>
						<p className="text-danger">{error}</p>
					</div>
					<div className="col-xs-12">
						<button
							className={`${Styles["btn-primary"]} btn pull-right`}
							disabled={loading || !validData}
							onClick={() => verifyEIDCredentials(data)}
						>
							{loading ? "Signing In..." : "Sign In"}
						</button>
					</div>
					<div className="clearfix"></div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state, { forBulkSubmission }) => {
	const { peNumber } = state.company?.settings;
	return {
		peNumber: forBulkSubmission ? undefined : peNumber,
		year: state.submissionForm?.year,
		error: state.submissionForm?.error,
		loading: state.submissionForm?.loadingEID,
		modalStatus: state.submissionForm?.eidLoginModal,
	};
};

const mapDispatchToProps = (dispatch, { forBulkSubmission, peNumber, year }) => ({
	closeModal: () => dispatch(FSS_REPORT_ACTIONS.openEIDModal()),
	verifyEIDCredentials: (body) =>
		dispatch(FSS_REPORT_ACTIONS.verifyEIDCredentials({ ...body, peNumber, year }, forBulkSubmission)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EIDLoginModal);
